<template>

  <div>

    <b-modal size="lg" @hide="onMountAgain('fields')" ref="modalFields" v-model="modalFields" id="modal-fields" hide-footer
             title="Editar campos customizados">

      <PageField v-if="modalFields" :enable-note="modalFieldEnableNote" :name="pageTitle" :foreign-key="pageId" />

    </b-modal>

    <b-modal size="lg" @hide="onMountAgain('view')" v-model="modalView" id="modal-view" hide-footer
             title="Editar visualização">
      <PageView v-if="modalView" :name="pageTitle" :foreign-key="pageId"/>
    </b-modal>

    <b-dropdown v-if="hasAccess()" id="dropdown-right" toggle-class="p-1" style="display: block !important;" no-caret dropleft variant="outline-gray">

      <template #button-content>
        <b-icon-three-dots-vertical></b-icon-three-dots-vertical>
      </template>


      <b-dropdown-item @click="openModalFields()" v-if="!disableEditField && relationAccessSubValidation('sub-action-general-edit-field')">
        Campos Customizados
      </b-dropdown-item>
      <b-dropdown-item @click="openModalView()" v-if="!disableEditView && relationAccessSubValidation('sub-action-general-edit-view')">
        Editar Exibição
      </b-dropdown-item>

      <slot name="add-items"></slot>


    </b-dropdown>

  </div>


</template>
<script>
import PageField from "@/views/modules/general/PageField"
import PageView from "@/views/modules/general/PageView"

export default {
  name: 't-page-list-right-buttons',
  components: {PageField, PageView},
  data() {
    return {
      pageTitle: "",
      pageId: 0,
      modalFields: false,
      modalView: false,

    }
  },
  props: {
    userAuth: Object,
    modalFieldEnableNote: Boolean,
    disableEditField: Boolean,
    disableEditView: Boolean,
  },
  mounted() {
    this.pageTitle = this.userAuth.currentPage.pageTitle
    this.pageId = this.userAuth.currentPage.pageId
  },

  methods: {

    onMountAgain(){
      this.$emit("onMountAgain")
    },

    hasAccess() {
      return this.relationAccessSubValidation('sub-action-general-edit-field') || this.relationAccessSubValidation('sub-action-general-edit-view')
    },

    relationAccessSubValidation(subValidationTag) {
      let e = this.userAuth.subValidations.find(el => el.subValidationTag === subValidationTag);
      return !!e;
    },

    openModalFields() {
      this.modalFields = true
    },

    openModalView() {
      this.modalView = true
    },

  }
}
</script>